import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ErrorReason, ErrorStatus } from '@tink/core/src/tinkLinkErrorCodes';
import { PaymentTransferDetailModel } from '../payments/models/payments';
import { CommonError } from './app-state-errors';

export enum PaymentDetailErrorType {
  OTHER = 'OTHER',
}

type PaymentTransferDetailsState = {
  data?: PaymentTransferDetails;
  error?: CommonError;
  loading: boolean;
};

type PaymentTransferDetails = PaymentTransferDetailModel;

const initialState: PaymentTransferDetailsState = {
  data: undefined,
  error: undefined,
  loading: false,
};

export const paymentTransferDetailsSlice = createSlice({
  name: 'paymentTransferDetails',
  initialState,
  reducers: {
    getPaymentTransferDetailsStart: (state) => {
      state.loading = true;
    },
    getPaymentTransferDetailsSuccess: (
      state,
      action: PayloadAction<PaymentTransferDetailModel>
    ) => {
      state.data = action.payload;
      state.error = undefined;
    },
    setPaymentTransferDetailsFailure: (state) => {
      state.error = {
        errorStatus: ErrorStatus.INTERNAL_ERROR,
        errorReason: ErrorReason.REQUEST_FAILED_FETCH_PAYMENT_INFO,
      };
    },
  },
});

export const {
  getPaymentTransferDetailsStart,
  getPaymentTransferDetailsSuccess,
  setPaymentTransferDetailsFailure,
} = paymentTransferDetailsSlice.actions;
